import React from 'react'

export default function FormError(props) {
    return (
        <span className="text-danger">{props.children}</span>
    )
}